import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function usePurchaseMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { type: 'CHASSIS' | 'WEAPON' | 'ITEM'; key: string, }
  >({
    mutationFn: (values) => api.post('/market/purchase', values),
  });
}
